import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { ArrowCircleLeft, ArrowCircleRight, Image } from "@mui/icons-material"
import OneModal from "../OneModal/OneModal"
import { useState } from 'react'

const CarrosselModal = ({ openCarrossel, setOpenCarrossel, images, selectedImageIndexInicial = 0 }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(selectedImageIndexInicial)

    const handleChangeImageSelected = (index) => {
        if (index < 0) index = images.length - 1
        if (index >= images.length) index = 0
        setSelectedImageIndex(index)
    }

    return (
        <OneModal
            open={openCarrossel}
            setOpen={setOpenCarrossel}
            titleText="Imagens"
            TitleIcon={Image}
        >
            <Grid
                container
                direction="row"
                sx={{
                    height: {
                        lg: '390px',
                        xl: '590px'
                    },
                    width: {
                        lg: '600px',
                        xl: '800px'
                    }
                }}
            >
                <Grid container item sx={{
                    height: {
                        lg: '290px',
                        xl: '490px'
                    },
                    width: '100%',
                    border: '1px solid black',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#02020286'
                }}>
                    <div
                        onClick={() => handleChangeImageSelected(selectedImageIndex - 1)}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '25px',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#ffffffd7'
                        }}>
                        <ArrowCircleLeft sx={{
                            height: '45px',
                            width: '45px'
                        }} />
                    </div>

                    {images[selectedImageIndex].url &&
                    <img
                        src={images[selectedImageIndex].url}
                        alt="Main Image"
                        style={{
                            height: '100%',
                            width: 'auto'
                        }}
                    />
                    }

                    <div
                        onClick={() => handleChangeImageSelected(selectedImageIndex + 1)}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: '25px',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            color: '#ffffffd7'
                        }}>
                        <ArrowCircleRight sx={{
                            height: '45px',
                            width: '45px'
                        }} />
                    </div>
                </Grid>
                <Grid
                    container
                    item
                    direction={'column'}
                    sx={{
                        height: {
                            lg: '110px',
                            xl: '110px'
                        },
                        width: '100%',
                        maxWidth: '100%',
                        border: '1px solid black',
                        backgroundColor: '#020202d0',
                        overflowX: 'auto',
                        overflowY: 'hidden',
                        alignContent: 'flex-start'
                    }}
                    ref={(gridRef) => {
                        if (gridRef) {
                            const selectedImageElement = gridRef.querySelector('.selected-image')
                            if (selectedImageElement) {
                                const gridRect = gridRef.getBoundingClientRect()
                                const selectedImageRect = selectedImageElement.getBoundingClientRect()
                                if (selectedImageRect.left < gridRect.left || selectedImageRect.right > gridRect.right) {
                                    gridRef.scrollLeft = selectedImageElement.offsetLeft
                                }
                            }
                        }
                    }}
                >
                    {images.map((image, index) => (
                        <div
                            className={selectedImageIndex == index ? 'selected-image' : ''}
                            style={{
                                height: '90px',
                                width: '100px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                border: selectedImageIndex == index ? '2px solid green' : '1px solid white'
                            }}
                        >
                            <img
                                src={image.url}
                                alt="Image"
                                style={{
                                    height: '100%',
                                    width: 'auto',
                                    maxWidth: '100%',
                                    cursor: 'pointer'
                                }}
                                onClick={() => handleChangeImageSelected(index)}
                            />
                        </div>
                    ))}
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default CarrosselModal
